export const DATA_SAVED = "dataSaved"
export const VERIFICATION_EMAIL_SENT = "verificationEmailSent"
export const PASSWORD_CHANGED = "passwordChanged"